import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { optimizelyInitialState } from './initialState';
import _ from 'lodash';

const selectDomain = (state: RootState) => state.optimizelyFlags || optimizelyInitialState;

export const selectOptimizelyFlags = createSelector([selectDomain], state => _.cloneDeep(state));